export const prop = {
  // host: 'test.agrobirja.az/api/v1',
  // host: 'api-msp.vac.az/api/v1',
  host: 'api.agrobirja.az/api/v1',
  appKey: ''
};
